<div class="percentage-bar">

  <div class="soma-progress-bar" [ngStyle]="{'width': progress + '%'}">
  </div>


</div>